"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadMore = void 0;

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _server = require("react-dom/server");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _truncHtml = _interopRequireDefault(require("trunc-html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReadMore =
/*#__PURE__*/
function (_Component) {
  _inherits(ReadMore, _Component);

  function ReadMore(props) {
    var _this;

    _classCallCheck(this, ReadMore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReadMore).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "html", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isExpanded: true
    });

    _this.html = (0, _lodash.isString)(props.content) ? props.content : (0, _server.renderToStaticMarkup)(_react.default.createElement(_react.default.Fragment, null, props.content));
    var RE = /(<([^>]+)>)/gi; // Strip HTML tags to get innerText char count

    var _this$html$replace = _this.html.replace(RE, ""),
        length = _this$html$replace.length; //


    var isExpanded = props.isExpanded || length < props.maxChars;
    _this.state = {
      isExpanded: isExpanded
    };
    return _this;
  }

  _createClass(ReadMore, [{
    key: "expandText",
    value: function expandText() {
      var _this2 = this;

      this.setState({
        isExpanded: true
      }, function () {
        _this2.props.onReadMoreClicked && _this2.props.onReadMoreClicked();
      });
    }
  }, {
    key: "getContent",
    value: function getContent() {
      if (this.state.isExpanded) {
        return this.html;
      } else {
        return (0, _truncHtml.default)(this.html, this.props.maxChars).html;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var content = this.getContent();
      var isExpanded = this.state.isExpanded || this.props.isExpanded;
      return _react.default.createElement(Container, {
        onClick: this.expandText.bind(this),
        isExpanded: isExpanded
      }, _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }), !this.state.isExpanded && _react.default.createElement(ReadMoreLink, null, "Read more"));
    }
  }]);

  return ReadMore;
}(_react.Component);

exports.ReadMore = ReadMore;

_defineProperty(ReadMore, "defaultProps", {
  isExpanded: false,
  maxChars: Infinity
});

ReadMore.displayName = "ReadMore";

var ReadMoreLink = function ReadMoreLink(_ref) {
  var children = _ref.children;
  return _react.default.createElement("span", null, " ", _react.default.createElement(ReadMoreLinkContainer, null, _react.default.createElement(ReadMoreLinkText, null, children)));
};

ReadMoreLink.displayName = "ReadMoreLink";

var ReadMoreLinkContainer = _styledComponents.default.span.withConfig({
  displayName: "ReadMore__ReadMoreLinkContainer",
  componentId: "sc-1bqy0ya-0"
})(["cursor:pointer;text-decoration:underline;display:inline-block;white-space:nowrap;"]); // NOTE: Couldn't use @artsy/palette / Sans due to root element being a `div`;
// as html content from CMS comes through as a p tag, markup is rendered invalid.


var ReadMoreLinkText = _styledComponents.default.span.withConfig({
  displayName: "ReadMore__ReadMoreLinkText",
  componentId: "sc-1bqy0ya-1"
})(["display:inline;font-family:Unica77LLWebMedium,\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-weight:500;font-size:12px;line-height:16px;"]);

var Container = _styledComponents.default.div.attrs({}).withConfig({
  displayName: "ReadMore__Container",
  componentId: "sc-1bqy0ya-2"
})(["cursor:", ";> span > *{margin-block-start:0;margin-block-end:0;padding-bottom:1em;}> span > *:last-child{display:inline;}"], function (p) {
  return p.isExpanded ? "auto" : "pointer";
});

Container.displayName = "Container";
//# sourceMappingURL=ReadMore.js.map